/**
 * Seção "Comportamento padrão" em modo leitura (Brief 4 · Tela 2 · PR2).
 *
 * Renderiza `sideDefault` (ADR-041) + `adversarialProfileDefault` (ADR-040) com
 * rótulo PT + descrição honesta de cada valor (sem os radios editáveis do
 * gabarito). Quando o perfil é `strict`, mostra a nota de que o modo H_c fica
 * bloqueado — renderizada CONDICIONALMENTE (nenhuma persona do seed é strict;
 * caso coberto por spec, não fabricado).
 */

import {
  adversarialDescription,
  adversarialLabel,
  sideDescription,
  sideLabel,
} from '../persona-labels';

import type { PersonaAdversarial, PersonaSide } from '../types';

export function SectionBehaviorRead({
  side,
  adversarial,
}: {
  side: PersonaSide;
  adversarial: PersonaAdversarial;
}): JSX.Element {
  const sideDesc = sideDescription(side);
  const advDesc = adversarialDescription(adversarial);

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Comportamento padrão</h2>
      <p className="pe-panel__subtitle">Lado representado e perfil adversarial.</p>
      <div className="pe-grid-2">
        <div className="pe-field">
          <span className="pe-field__label">Lado padrão</span>
          <p className="pe-read-value">{sideLabel(side)}</p>
          {sideDesc !== '' && <p className="pe-read-value pe-read-value--muted">{sideDesc}</p>}
        </div>
        <div className="pe-field">
          <span className="pe-field__label">Perfil adversarial</span>
          <p className="pe-read-value">{adversarialLabel(adversarial)}</p>
          {advDesc !== '' && <p className="pe-read-value pe-read-value--muted">{advDesc}</p>}
        </div>
      </div>
      {adversarial === 'strict' && (
        <p className="pe-note pe-note--warning" role="note">
          Modo H_c bloqueado em conversas desta persona — perfil adversarial estrito, disponível
          apenas no pacote Regulated.
        </p>
      )}
    </section>
  );
}
